// 集中管理 localStorage 的 key，避免散落字符串

export const STORAGE_KEYS = {
  settings: "pomodoro:settings",
  todos: "pomodoro:todos",
  stats: "pomodoro:stats",
  activeTodoId: "pomodoro:activeTodoId",
  completedInRound: "pomodoro:completedInRound"
} as const;

/** 返回 'YYYY-MM-DD' 格式（本地时区） */
export function todayKey(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** 简单 UUID（浏览器无 crypto.randomUUID 兼容性时也工作） */
export function uid(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}
